<template>
  <icon-base
    :title="title"
    :name="name"
    :viewbox="viewBox">
    



<g>
	<path d="M12,15.75c-3.308,0-6-2.692-6-6s2.692-6,6-6s6,2.692,6,6S15.308,15.75,12,15.75z M12,5.25c-2.481,0-4.5,2.019-4.5,4.5
		s2.019,4.5,4.5,4.5c2.481,0,4.5-2.019,4.5-4.5S14.481,5.25,12,5.25z"/>
	<path d="M12,24c-2.677,0-5.211-0.868-7.332-2.51c-0.021-0.012-0.066-0.038-0.11-0.082c-0.005-0.005-0.011-0.011-0.016-0.017
		C1.655,19.094,0,15.674,0,12C0,5.383,5.383,0,12,0c6.617,0,12,5.383,12,12c0,3.674-1.655,7.094-4.543,9.391
		c-0.005,0.006-0.01,0.011-0.015,0.016c-0.043,0.043-0.087,0.069-0.112,0.084C17.211,23.132,14.677,24,12,24z M6.284,20.801
		C7.99,21.914,9.956,22.5,12,22.5c2.045,0,4.011-0.586,5.717-1.699c-1.604-1.322-3.616-2.045-5.716-2.045
		C9.901,18.755,7.889,19.479,6.284,20.801z M12,1.5C6.21,1.5,1.5,6.21,1.5,12c0,3.023,1.294,5.875,3.562,7.874
		c1.915-1.69,4.366-2.617,6.938-2.617c2.573,0,5.023,0.927,6.938,2.616c2.268-2,3.562-4.851,3.562-7.874C22.5,6.21,17.79,1.5,12,1.5
		z"/>
</g>


  </icon-base>
</template>

<script>
import IconBase from '../IconBase';

export default {
  components: {
    IconBase,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: 'single-neutral-circle',
    },
    name: {
      type: String,
      required: false,
      default: 'SingleNeutralCircle',
    },
    viewBox: {
      type: String,
      required: false,
      default: '0 0 24 24',
    },
  },
};
</script>

<style scoped>
  
</style>